<template>
  <div class="wrapper">
    <video
      ref="RvVideo"
      loop
      playsinline
      muted="muted"
      class="video"
      type="video/mp4"
    >
      <source :src="src" type="video/mp4" />
    </video>

    <!-- <div class="overlay overlay&#45;png" /> -->

    <div class="overlay" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BgVideo',

  props: {
    src: {
      type: [String, Boolean],
      default: 'uploads/looping-background.mp4'
    }
  },

  computed: {
    ...mapState(['ytIsPlaying', 'bgVideoIsPlaying', 'bgVideoWasPlaying']),

    video() {
      return this.$refs.RvVideo
    }
  },

  watch: {
    bgVideoIsPlaying() {
      if (this.video.paused) {
        this.video.play()
      } else {
        this.video.pause()
      }
    },

    ytIsPlaying(newVal) {
      if (newVal) {
        this.$store.commit('toggleBgVideoState', false)
      }

      if (!newVal && this.bgVideoWasPlaying) {
        this.$store.commit('toggleBgVideoState', true)
      }
    }
  },

  mounted() {
    if (this.bgVideoIsPlaying) return this.video.play()
  }
}
</script>

<style scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
}

.video {
  height: auto;
  left: 50%;
  max-height: none;
  max-width: none;
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
}

.overlay {
  background-color: #000;
  min-height: 100%;
  left: 0;
  opacity: 0.2;
  position: absolute;
  top: 0;
  min-width: 100%;
}

.overlay-png {
  /* background-image: url('../../src/assets/video-overlay.png'); */
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAANklEQVQYlWNYtWqVMQMSWLVqlTE2MQZcAhiS+CQImoTVZGyKsComWiHRVpPkGVyewqsLV4ADAEr5TuVwzxgzAAAAAElFTkSuQmCC)
    repeat;

  opacity: 0.9;
}
</style>
